import React from 'react';

import ErrorList from 'ui-library/spec-editor/ErrorList';

interface AssaySchemaErrorListProps {
  errors: Array<string>;
  component: string;
}

const AssaySchemaErrorList = (props: AssaySchemaErrorListProps): JSX.Element => (
  <ErrorList
    errors={props.errors.length ? props.errors : null}
    errorMessage={props.errors.length ? `Invalid ${props.component.toLowerCase()}` : null}
  />
);

export default AssaySchemaErrorList;
